import React from "react";
import FirstFooter from "./FirstFooter";
import SecondFooter from "./SecondFooter";

const Footer = () => {
  return (
    <footer>
      <FirstFooter />
      <SecondFooter />
    </footer>
  );
};

export default Footer;
